import type { MyIssuedRosterResponse } from "@/hooks/useMyIssuedRoster";
import { normalizeScheduleCellCode } from "@/utils/shift-util";
import {
  issuedCellStatus,
  assignmentReasonLabel,
} from "./issuedCellPresentation";

export function defaultRosterDay(
  year: number,
  month: number,
  today = new Date()
): number {
  return today.getFullYear() === year && today.getMonth() + 1 === month
    ? today.getDate()
    : 1;
}

export function myRosterDayDetails(
  roster: MyIssuedRosterResponse,
  day: number,
  shifts: readonly {
    shift_id: string;
    name?: string | null;
    color?: string | null;
  }[],
  fallbackWardId?: string | null
) {
  const raw = roster.schedule[day - 1];
  const cell = raw && typeof raw === "object" ? raw : undefined;
  const status = issuedCellStatus(cell);
  const code = status === "미발행" ? "" : normalizeScheduleCellCode(raw).trim();
  const wardId =
    cell?.target_group_id ||
    cell?.group_id ||
    fallbackWardId ||
    roster.source_group_id ||
    roster.home_group_id ||
    "";
  const transfer = (
    roster.transfers ?? (roster.transfer ? [roster.transfer] : [])
  ).find(
    (item) =>
      item.target_group_id === wardId &&
      day >= item.period_start_day &&
      day <= item.period_end_day
  );
  const ward = roster.ward_counts?.find((item) => item.group_id === wardId);
  const wardShift =
    (cell?.schedule_id != null
      ? ward?.shifts.find((shift) => shift.schedule_id === cell.schedule_id)
      : undefined) ?? ward?.shifts.find((shift) => shift.code === code);
  const catalogShift = shifts.find((shift) => shift.shift_id === code);
  return {
    code,
    name: wardShift?.name || catalogShift?.name || code,
    color:
      cell?.color ||
      wardShift?.color ||
      roster.shift_colors[code] ||
      catalogShift?.color ||
      "#d6d6de",
    wardName:
      cell?.target_group_name ||
      cell?.group_name ||
      ward?.group_name ||
      roster.groups?.find((item) => item.group_id === wardId)?.group_name ||
      transfer?.target_group_name ||
      (wardId === roster.source_group_id || wardId === roster.home_group_id
        ? roster.source_group_name || roster.home_group_name
        : undefined) ||
      wardId ||
      "—",
    reason: assignmentReasonLabel(
      cell?.reason ||
        (!cell?.group_id && !cell?.target_group_id
          ? transfer?.reason
          : undefined) ||
        "—"
    ),
    status,
    coworkers: Array.isArray(cell?.coworkers)
      ? cell.coworkers.filter((nurse) => nurse.nurse_id !== roster.nurse_id)
      : null,
  };
}
